import { useContext } from 'react'
import { IoCloseCircleOutline } from 'react-icons/io5'
import { ModalTotalContext } from '../../../../context/ModalContext'
import { ButtonSubmit, color } from '../../../../GlobalStyle'
import Base from '../index'
import { ContentModalPop, FlexButtonDiv } from './style'

const ModalConfirmDelete = ({ callBack }) => {
  const { setOpenModal } = useContext(ModalTotalContext)

  return (
    <Base width={'380px'} height={'350px'} setOpenModal={setOpenModal}>
      <ContentModalPop>
        <IoCloseCircleOutline />
        <h3>Você tem certeza?</h3>
        <p>Você realmente quer deletar? Esse processo não pode ser desfeito</p>

        <FlexButtonDiv>
          <ButtonSubmit
            type="button"
            background={color.cancel}
            width={'100%'}
            onClick={() => setOpenModal(false)}
          >
            Não
          </ButtonSubmit>
          <ButtonSubmit type="button" onClick={() => callBack()} width={'100%'}>
            Sim
          </ButtonSubmit>
        </FlexButtonDiv>
      </ContentModalPop>
    </Base>
  )
}
export default ModalConfirmDelete
